type NativeBack = { show(): void; hide(): void; onClick(callback: () => void): void; offClick(callback: () => void): void };
type NativeHost = { Telegram?: { WebApp?: { BackButton?: NativeBack; isVersionAtLeast?(version: string): boolean } } };
/** Register one native callback for the lifetime of the full-screen market. */
export function installMarketNativeBack(back: () => void, host: NativeHost = window as unknown as NativeHost): () => void {
  const app = host.Telegram?.WebApp, button = app?.BackButton;
  if (!button || (app?.isVersionAtLeast && !app.isVersionAtLeast("6.1"))) return () => undefined;
  button.onClick(back); button.show();
  let disposed = false;
  return () => { if (disposed) return; disposed = true; button.offClick(back); button.hide(); };
}
